import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from '../shared/context/AppContext';
import { ChatProvider } from '../shared/context/ChatContext';
import LandingPage from '../features/landing/LandingPage';
import AuthContainer from '../features/auth/AuthContainer';
import Dashboard from '../features/dashboard/Dashboard';
import CallScreen from '../features/call/CallScreen';
import './styles/index.css';

const AppRoutes = () => {
  const { isAuthenticated, activeCall, remoteSocketId, endCall, socket, dispatch } = useApp();
  const [showAuth, setShowAuth] = useState(false);
  const [pendingRoomId, setPendingRoomId] = useState(() => {
    // Allow deep-linking to a room via ?room=... (instant meetings).
    const params = new URLSearchParams(window.location.search);
    return params.get('room') || '';
  });

  useEffect(() => {
    if (isAuthenticated && pendingRoomId) {
      // Auto-join a room after successful auth.
      dispatch({
        type: 'SET_ACTIVE_CALL',
        payload: { id: pendingRoomId, isVideo: true, isRoom: true, roomId: pendingRoomId },
      });
      setPendingRoomId('');
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [dispatch, isAuthenticated, pendingRoomId]);

  // If user is not authenticated
  if (!isAuthenticated) {
    // Show auth form if user clicked Sign In or Host
    if (showAuth || pendingRoomId) {
      return (
        <AuthContainer
          onBack={() => {
            setShowAuth(false);
            setPendingRoomId('');
            window.history.replaceState({}, document.title, window.location.pathname);
          }}
        />
      );
    }
    // Otherwise show landing page
    return (
      <LandingPage 
        onSignIn={() => setShowAuth(true)}
        onHostMeeting={() => setShowAuth(true)}
        onJoinMeeting={(meetingId) => {
          setPendingRoomId(meetingId);
          setShowAuth(true);
        }}
      />
    );
  }

  // If user is in an active call, show call screen
  if (activeCall) {
    return (
      <CallScreen 
        remoteSocketId={remoteSocketId} 
        onEndCall={endCall}
        socket={socket}
      />
    );
  }

  // Otherwise show dashboard
  return <Dashboard />;
};

const App = () => {
  return (
    <AppProvider>
      <ChatProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<AppRoutes />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Router>
      </ChatProvider>
    </AppProvider>
  );
};

export default App;